import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axios";

export const fetchSkills = createAsyncThunk(
  "app/fetchSkills",
  async (_, { getState }) => {
    const { skills } = getState().initialData;
    if (skills?.length === 0) {
      const response = await axios.get(`/api/v1/school/skill/get`);
      return response.data.data;
    }
    return skills;
  }
);

// Async thunk to fetch difficultyLevels if not in store
export const fetchDifficultyLevels = createAsyncThunk(
  "app/fetchDifficultyLevels",
  async (_, { getState }) => {
    const { difficultyLevels } = getState().initialData;
    if (difficultyLevels?.length === 0) {
      const response = await axios.get(`/api/v1/difficultyLevel/get`);
      return response.data.data;
    }
    return difficultyLevels;
  }
);

// Async thunk to fetch all student list if not in store
export const fetchAllStudentList = createAsyncThunk(
  "app/fetchAllStudentList",
  async (school_id, { getState }) => {
    const { getAllStudentList } = getState().initialData;
    if (getAllStudentList?.length === 0) {
      const response = await axios.get(
        `/api/v1/school/student/get/school/${school_id}`
      );
      return response.data.data;
    }
    return getAllStudentList;
  }
);

// Async thunk to fetch all teacher list if not in store
export const fetchAllTeacherList = createAsyncThunk(
  "app/fetchAllTeacherList",
  async (school_id, { getState }) => {
    try {
      const { getAllTeacherList } = getState().initialData;
      if (getAllTeacherList?.length === 0) {
        const response = await axios.get(
          `/api/v1/school/teacher/get/school/${school_id}`
        );
        return response.data.data;
      }
      return getAllTeacherList;
    } catch (error) {
      console.log(error);
    }
  }
);

// Async thunk to fetch questionTypes if not in store
export const fetchQuestionTypes = createAsyncThunk(
  "app/fetchQuestionTypes",
  async (school_id, { getState }) => {
    const { questionTypes } = getState().initialData;
    if (questionTypes?.length === 0) {
      const response = await axios.get(
        `/api/v1/questionType/get/school/${school_id}`
      );
      return response.data.data;
    }
    return questionTypes;
  }
);

// Async thunk to fetch questionTypes if not in store
export const fetchDomainData = createAsyncThunk(
  "app/fetchDomainData",
  async (_, { getState }) => {
    const { domain } = getState().initialData;
    if (domain?.length === 0) {
      const response = await axios.get(`/api/v1/school/domain/get`);
      return response.data.data;
    }
    return domain;
  }
);

const initialDataSlice = createSlice({
  name: "initialData",
  initialState: {
    skills: [],
    difficultyLevels: [],
    domain: [],
    questionTypes: [],
    userInformation: {},
    getAllStudentList: [],
    getAllTeacherList: [],
    isRouteLoading: false,
    schoolId: null,
    status: "idle", // for handling loading state
    error: null,
  },
  reducers: {
    setUserInformation: (state, action) => {
      state.userInformation = action.payload;
    },
    setSchoolId: (state, action) => {
      state.schoolId = action.payload;
    },
    setRouteLoading: (state, action) => {
      state.isRouteLoading = action.payload;
    },
  }, // No need for manual reducers here as thunks handle updates
  extraReducers: (builder) => {
    builder
      .addCase(fetchSkills.fulfilled, (state, action) => {
        state.skills = action.payload;
      })
      .addCase(fetchDifficultyLevels.fulfilled, (state, action) => {
        state.difficultyLevels = action.payload;
      })
      .addCase(fetchQuestionTypes.fulfilled, (state, action) => {
        state.questionTypes = action.payload;
      })
      .addCase(fetchDomainData.fulfilled, (state, action) => {
        state.domain = action.payload;
      })
      .addCase(fetchAllStudentList.fulfilled, (state, action) => {
        state.getAllStudentList = action.payload;
      })
      .addCase(fetchAllTeacherList.fulfilled, (state, action) => {
        state.getAllTeacherList = action.payload;
      })
      .addCase(fetchSkills.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(fetchDifficultyLevels.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(fetchQuestionTypes.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(fetchDomainData.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(fetchAllStudentList.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(fetchAllTeacherList.rejected, (state, action) => {
        state.error = action.error.message;
      });
  },
});

export const { setUserInformation, setSchoolId, setRouteLoading } =
  initialDataSlice.actions;
export default initialDataSlice.reducer;
